// Color tokens for the Admin Analytics dashboard.
//
// The dashboard is authored in Tailwind (layout, typography, spacing), but
// charts (recharts) and computed inline styles (bar widths, dynamic fills)
// need concrete color values. Those live here, remapped from the reference
// prototype's green/amber scheme onto the workspace palette (workspace.css)
// so the dashboard matches the rest of the app.

export const T = {
  green900: "#123E32", // frame
  green800: "#28543D", // green
  green700: "#28543D", // green (primary)
  green500: "#6E9A7B", // light green (accent)
  green100: "#C9D9C4",
  green50: "#EEF0E3",
  amber500: "#C9A14A", // gold
  peach100: "#FBF0DC", // warning tint
  declineInk: "#8A5A1C",
  ink900: "#294B39", // ink
  ink600: "#687368", // muted
  gray50: "#F3EDE2", // linen
  white: "#FFFFFF",
} as const;

export type MasteryLevel =
  | "notStarted"
  | "approaching"
  | "proficient"
  | "mastered";

export const LEVELS: {
  key: MasteryLevel;
  label: string;
  color: string;
  outlined?: boolean;
}[] = [
  { key: "notStarted", label: "Not started", color: T.white, outlined: true },
  { key: "approaching", label: "Approaching", color: T.amber500 },
  { key: "proficient", label: "Proficient", color: T.green500 },
  { key: "mastered", label: "Mastered", color: T.green700 },
];

export const levelColor: Record<MasteryLevel, string> = {
  notStarted: T.white,
  approaching: T.amber500,
  proficient: T.green500,
  mastered: T.green700,
};

// Proficiency tier colors, shared across the on-track visualizations.
export const TIER_COLORS = {
  onTrack: T.green700,
  borderline: T.amber500,
  notOnTrack: "#B83A30",
  notStarted: "#DAD4C7",
} as const;
